
import { createNamespacedHelpers } from '@/common/vuex-composition-hooks';
import { defineComponent, onBeforeMount, reactive, toRefs } from 'vue';
import { IAuthActions, IAuthGetters, IAuthState } from '../login/types';
import headerFiltersDash from '@/components/headerFiltersDash.vue';
const Auth = createNamespacedHelpers<IAuthState, IAuthGetters, IAuthActions>(
  'auth'
);

import { useRoute } from 'vue-router';
import { firstUpperString } from '@/common/helpers/FirstUpperString';
import { mapActions } from 'vuex';
import { RefreshTime } from '@/common/enums/RefreshTime';

interface State {
  brandFilters: IFilter[];
  salesChannelFilters: IFilter[];
  billingUnitsEmp: IFilter[];
  billingUnitsFil: IFilter[];
  segmentFilters: IFilter[];
}

interface IFilter {
  id?: number;
  index?: number;
  name?: string;
  fullname: string;
  selected?: boolean;
  code?: any;
  route?: string;
  module?: string;
}

export default defineComponent({
  components: {
    headerFiltersDash,
  },

  data() {
    return {
      filters: [
        {
          data: 'brandFilters',
          name: 'Marcas',
          param: 'brandCodes',
          type: 'string',
        },
        {
          data: 'billingUnitsEmp',
          name: 'Empresas',
          param: 'billingUnitsEmp',
          type: 'number',
        },
        {
          data: 'billingUnitsFil',
          name: 'Filiais',
          param: 'billingUnitsFil',
          type: 'number',
        },
      ],
      filtersCalendar: {
        maxDate: '',
        minDate: '',
        date: '',
      },
      searchParams: {} as State,
      currentIndex: 0,
      intervalId: null as number | null,
    };
  },

  computed: {},

  methods: {
    ...mapActions('dashboardStock', {
      fetchPendingEntryOrders: 'fetchPendingEntryOrders',
      fetchCardsOrders: 'fetchCardsOrders',
      fetchOpenOrders: 'fetchOpenOrders',
      setSearchParams: 'setSearchParams',
      setSearchDate: 'setSearchDate',
    }),
    ...mapActions('auth', ['setFilteredDateYYYYMM']),

    setInitialSearchParams() {
      this.filters.forEach((filter) => {
        this.searchParams[filter.data] = this[filter.data];
      });
    },

    clearFilters() {
      this.filters.forEach((filter) => {
        this.searchParams[filter.data].forEach((el) => {
          el.selected = false;
        });
      });
      this.applySearchParams();
    },

    applySearchParams(filters?) {
      this.setSearchParams(filters);
      this.fetchPendingEntryOrders();
      this.fetchOpenOrders();
      this.fetchCardsOrders();
    },
    UpdateParams(params) {
      this.searchParams = params;
    },

    startAutoRefresh() {
      this.intervalId = window.setInterval(() => {
        this.fetchPendingEntryOrders();
        this.fetchOpenOrders();
        this.fetchCardsOrders();
      }, RefreshTime.TIMES);
    },

    stopAutoRefresh() {
      if (this.intervalId !== null) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
  },

  setup() {
    const { brands } = Auth.useState(['brands']);
    const { salesChannel } = Auth.useState(['salesChannel']);
    const { billingUnits } = Auth.useState(['billingUnits']);
    const { sessionUser, getFilteredDateYYYYMM } = Auth.useGetters([
      'sessionUser',
      'getFilteredDateYYYYMM',
    ]);

    const { SET_ACCESS_TYPE } = Auth.useMutations(['SET_ACCESS_TYPE']);

    const { sessionUpdate } = Auth.useActions(['sessionUpdate']);

    const route = useRoute();

    onBeforeMount(() => SET_ACCESS_TYPE('panel'));

    const state: State = reactive<State>({
      brandFilters: [],
      salesChannelFilters: [],
      billingUnitsEmp: [],
      billingUnitsFil: [],
      segmentFilters: [],
    });

    brands?.value?.forEach((el, index) => {
      state.brandFilters.push({
        id: index,
        fullname: firstUpperString(el.name),
        selected: false,
        code: el.code,
      });
    });

    salesChannel?.value?.forEach((el, index) => {
      state.salesChannelFilters.push({
        id: index,
        fullname:
          el.name == 'export' ? 'Exportação' : firstUpperString(el.name),
        selected: false,
        code: el.code,
      });
    });

    billingUnits?.value?.forEach((el) => {
      const emp = {
        id: state.billingUnitsEmp.length,
        fullname: String(el.businessCode),
        selected: false,
        code: el.businessCode,
      };

      const fil = {
        id: state.billingUnitsFil.length,
        fullname: String(el.subsidiaryCode),
        selected: false,
        code: el.subsidiaryCode,
      };

      if (!state.billingUnitsEmp.some((e) => e.code === emp.code)) {
        state.billingUnitsEmp.push(emp);
      }
      if (!state.billingUnitsFil.some((e) => e.code === fil.code)) {
        state.billingUnitsFil.push(fil);
      }
    });

    state.segmentFilters = [
      {
        id: 0,
        fullname: 'Calçado',
        selected: false,
        code: 1,
      },
      {
        id: 1,
        fullname: 'Acessório',
        selected: false,
        code: 2,
      },
      {
        id: 2,
        fullname: 'Confecção',
        selected: false,
        code: 5,
      },
    ];

    return {
      ...toRefs(state),
      SET_ACCESS_TYPE,
      sessionUpdate,
      sessionUser,
      route,
      getFilteredDateYYYYMM,
    };
  },

  beforeMount() {
    this.setInitialSearchParams();
  },

  mounted() {
    this.startAutoRefresh();
  },

  beforeUnmount() {
    this.stopAutoRefresh();
  },
});
